// components/main/Header.tsx

import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { ScrollLeft, ScrollRight } from "../../assets/icons";
import { HeaderProps, NavBGProps } from "./types";

export const Header = ({
  icon,
  title,
  viewAllUrl,
  onScrollLeft,
  onScrollRight,
  scrollState,
}: HeaderProps) => {
  const { t } = useTranslation();
  const translate = t as unknown as (key: string) => string;
  const isHome = useLocation().pathname === "/";

  return (
    <div className="row-1 justify-between">
      {/* icon and title */}
      <div className="row-2 items-center">
        <img src={icon} alt={title} className="size-8 pb-[6px]" />
        <span className="lt-xl-semibold-black bp:satoshi-xl-bold-black dark:text-white">
          {translate(title)}
        </span>
      </div>

      {/* nav icons and view all */}
      <div className="row-4 items-center">
        {isHome && (
          <div className="hidden bp:row-2">
            <NavBG
              icon={ScrollLeft}
              isActive={scrollState?.left ?? false}
              onClick={onScrollLeft}
            />
            <NavBG
              icon={ScrollRight}
              isActive={scrollState?.right ?? false}
              onClick={onScrollRight}
            />
          </div>
        )}
        {isHome && viewAllUrl && (
          <a
            href={`view-all/${viewAllUrl}`}
            className="satoshi-lg-medium-main-light dark:text-main-dark"
          >
            {translate("main.viewAll")}
          </a>
        )}
      </div>
    </div>
  );
};

const NavBG = ({ icon: Icon, isActive, onClick }: NavBGProps) => {
  return (
    <button
      onClick={onClick}
      disabled={!isActive}
      className="bg-navBG dark:bg-BG-dark flex justify-center items-center size-8 rounded-full"
    >
      <Icon isActive={isActive} />
    </button>
  );
};
